import { PropsWithChildren } from "react";
import clsx from "clsx";
import { Icon } from "react-migration/components/Icon";
import { Transaction, TransactionPurchaseType } from "react-migration/domains/ownership/typings/Transaction";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

interface WrapperProps extends PropsWithChildren {
  icon: string;
  className?: string;
}

function Wrapper({ children, icon, className }: WrapperProps) {
  return (
    <div className={clsx("flex items-center rounded-sm border border-border-action p-2 grow", className ?? "bg-white")}>
      <Icon size="lg" extraClasses="me-4 ps-2" icon={icon} />
      <div className="grow">{children}</div>
    </div>
  );
}

interface PriceProps extends PropsWithChildren {
  onClick(): void;
}

function Price({ onClick, children }: PriceProps) {
  return (
    <div className="text-xs font-semibold cursor-pointer text-text-base-active" onClick={onClick}>
      {children}
    </div>
  );
}

interface ViewPurchasedProps {
  transaction: Transaction;
  titleType: TransactionPurchaseType;
}

function ViewPurchased({ transaction, titleType }: ViewPurchasedProps) {
  const { t } = useTranslation();
  const isPhysical = transaction.state?.type === "title_doc_success_physical";

  return isPhysical ? (
    <>{t("ownership.titles_section.physical")}</>
  ) : (
    <a
      rel="noreferrer"
      href={transaction.purchase?.title_document?.url}
      target="_blank"
      className="font-semibold cursor-pointer text-text-base-active"
    >
      {titleType === TransactionPurchaseType.TITLE_PLAN_DOCUMENT
        ? t("ownership.titles_section.view_title_plan")
        : t("ownership.titles_section.view_title_register")}
    </a>
  );
}

function Heading({ children }: PropsWithChildren) {
  return <div className="text-xs">{children}</div>;
}

export const PurchaseTitle = {
  Wrapper,
  Heading,
  Price,
  ViewPurchased,
};
